import { render, staticRenderFns } from "./LoginForm.vue?vue&type=template&id=670488d7&"
import script from "./LoginForm.vue?vue&type=script&lang=js&"
export * from "./LoginForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InputText: require('/var/www/vhosts/bloonde.es/lareverdetienda.bloonde.es/components/inputs/InputText.vue').default})
